/** Formatting helpers for Service estimates. MARCO: swap `money` for AE2's displayValue if it formats currency the same way. */
export const money = (v: number | string | null | undefined): string =>
  '$' + Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const pct = (v: number | string | null | undefined): string =>
  v === null || v === undefined || v === '' ? '—' : `${Math.round(Number(v) * 1000) / 10}%`;

export const shortDate = (iso: string | null | undefined): string => {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${Number(m)}/${Number(d)}/${y}`;
};

export const todayIso = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  ready: 'Ready to send',
  sent: 'Sent',
  accepted: 'Accepted',
  declined: 'Declined',
  expired: 'Expired',
};

export const STATUS_COLOR: Record<string, string> = {
  draft: 'medium',
  ready: 'success',
  sent: 'primary',
  accepted: 'success',
  declined: 'danger',
  expired: 'danger',
};

export const ACS_PATTERN = /^ACS\d{2}-\d{4}$/;
